<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#grasimi2plus">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Grăsimi, din care</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">24.6 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">3.4 g</span></div>

    </div>

    <div id="grasimi2plus" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grasi saturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">8.0 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.1 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grasi mononesaturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">12.4 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.7 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acizi grași polinesaturați</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">4.2 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.6 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid arahidonic (AA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.12 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0165 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid docosahexaenoic (DHA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.12 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0165 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid linoleic (LA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.3 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.456 g</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid alfa-linolenic (ALA)</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.40 g</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.0547 g</span></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "grasimi",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>
.active-grasimi {
  background: #F8F8F8;
}
</style>
